module.exports = __webpack_public_path__ + "img/button.236fc87d.png";